module.exports = __webpack_public_path__ + "static/media/usd.791ad1e4.svg";